import * as React from "react";
import { styled } from "@mui/material";
import { PatientColorMap } from "../../layout/patientColorMap";
import {
  WaveContainerBackground,
  WaveHeader,
  WaveHeaderBackground,
  WaveInnerWrapper,
  WaveOuterWrapper,
} from "../../style/useWaveStyles";

//region [[ Styles ]]

const WaveLandingPageView = styled("div")({
  position: "relative",
  display: "flex",
  flexFlow: "column",
  height: "100%",
  flexDirection: "column",
  "--grad-light": "#9F99EA",
  "--grad-dark": "#5A52C3",
  width: "100%",
});

const BottomArea = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
});

const Title = styled("div")({
  fontSize: "24px",
  marginBottom: "20px",
  fontWeight: "bold",
  color: "#FFFFFF",
});

const Text = styled("div")({
  fontSize: "17px",
  fontWeight: 500,
  color: "#FFFFFF",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface WaveLandingPageProps {
  children?: React.ReactNode;
  bottom?: React.ReactNode;
  title?: string;
  contentText?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const WaveLandingPage = ({ ...props }: WaveLandingPageProps) => {
  const useGradient = "true";
  return (
    <WaveLandingPageView>
      <WaveContainerBackground
        color={PatientColorMap.GradLight}
        gradient={useGradient}
        key={"containerBackground" + useGradient}
      />
      <WaveHeaderBackground
        color={PatientColorMap.GradLight}
        gradient={useGradient}
        key={"headerBackground" + useGradient}
      />
      <WaveHeader
        color={PatientColorMap.GradLight}
        gradient={useGradient}
        key={"header" + useGradient}
      >
        {!!props.title && <Title>{props.title}</Title>}
        {!!props.contentText && <Text>{props.contentText}</Text>}
        {props.children}
      </WaveHeader>
      <WaveOuterWrapper
        color={PatientColorMap.GradDark}
        gradient={"false"}
        key={"outerWrapper" + useGradient}
      >
        <WaveInnerWrapper>
          <BottomArea>{props.bottom}</BottomArea>
        </WaveInnerWrapper>
      </WaveOuterWrapper>
    </WaveLandingPageView>
  );
};
